export function wc_slicks() {
  $('.wc-block-grid__products').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: true,
    centerPadding: '40px',
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          infinite: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // slick-slider för related products
  if((window.innerWidth > 1024 && $('.product-related-products .related .product').length > 4) || (window.innerWidth < 1025 && $('.product-related-products .related .product').length > 1)) {
    $('.product-related-products .related .products').slick({
      dots: false, // från true
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      // centerMode: true,
      // centerPadding: '40px',
    //  autoplay: true,
    //  autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: false,
            infinite: false,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if($('.news-block').length > 0) {
    $('.news-content').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '0',
      autoplay: true,
      autoplaySpeed: 15000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '40px',
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '40px',
          }
        }
      ]
    });
    title_dots();
    check_for_changes_news_block();
  }
}

function title_dots() {
  let counter = 0;
  let number_of_titles = $('.slick-dots li').length;
  let title = $(this).attr('title');
  $('.news-block .slick-list .news-div').each(function(i,e) {
    if(i>1) {
      let title = $('.news-div-text', this).attr('title');
      if(counter <= number_of_titles) {
        $('.slick-dots li button').eq(counter).text(title);
      }
      counter++;
    }
  });
}


function check_for_changes_news_block() {
  let interval = setInterval(()=> {
      let test = $('.slick-dots li button').eq(0).text();
      if(test == 1) {
        title_dots();
      }
    }, 200);
}
